import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6e6f8ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "day-homework_row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon_wrapper" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_2707_72958)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M7.525 4.00006L9.9995 6.47514L4.2245 12.2496H1.75V9.77448L7.525 3.99948V4.00006ZM8.34983 3.17523L9.58708 1.93739C9.69647 1.82804 9.84482 1.7666 9.9995 1.7666C10.1542 1.7666 10.3025 1.82804 10.4119 1.93739L12.0622 3.58764C12.1715 3.69704 12.233 3.84538 12.233 4.00006C12.233 4.15474 12.1715 4.30309 12.0622 4.41248L10.8243 5.64973L8.34983 3.17523Z",
        fill: "#FBFBFD"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2707_72958" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "14",
          height: "14",
          fill: "white"
        })
      ])
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "day-homework_column" }
const _hoisted_5 = { class: "day-homework_row day-homework_subTitle" }
const _hoisted_6 = { class: "day-homework_row day-homework_title" }
const _hoisted_7 = { class: "day-homework_row -space-between -mt" }
const _hoisted_8 = { class: "day-homework_column day-homework_type" }
const _hoisted_9 = { class: "day-homework_column day-homework_status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.link,
    class: _normalizeClass(['day-homework', `-${_ctx.homework.status.status}`, _ctx.isDisabled ? '-disabled' : '']),
    disabled: _ctx.isDisabled,
    event: _ctx.isDisabled ? '' : 'click'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["day-homework_column day-homework_icon icon", [`-${_ctx.homework.status.status}`, _ctx.isDisabled ? '-disabled' : '']])
        }, _hoisted_3, 2),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('task')), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.homework.homework.title), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('homework')), 1),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(`homeworkStatuses['${_ctx.homework.status.status}']`)), 1)
      ])
    ]),
    _: 1
  }, 8, ["to", "class", "disabled", "event"]))
}